export default "__VITE_ASSET__d0f8e373__"